import React, { Component, forwardRef } from 'react';
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from '../../../actions/fillCombo_action'
import Pagination from '../../../utils/pagination'
import DatePicker from "react-datepicker";
import Header from '../../../common_components/Header';
import { BASE_URL, toastError, toastSuccess } from '../../../utils/constants';
import { getBlogList_action, deleteBlog_action } from '../../../actions/adminAction/blog_action'
import moment from 'moment';
import { Modal } from 'react-bootstrap';


const ExampleCustomInput = forwardRef(({ value, onClick, onChange, disabled }, ref) => (
    <input
        value={value}
        className="form-control"
        onClick={onClick}
        onChange={onChange}
        disabled={disabled}
        ref={ref}
    ></input>
));


class BlogList extends Component {

    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            isOpen: false,
            isFilterShow: false,
            blogList: [],
            title: '',
            blogFrom: '',
            blogTo: '',
            currentPage: 1,
            recordsPerPage: 10,
            isActive: '',
            isSocial: false,
            BlogID: '',
            StatusId: '',
            BlogTitle: '',
            BlogContent: '',
        }
        this.updateItem = this.updateItem.bind(this);
        this.updateRecordsPerPage = this.updateRecordsPerPage.bind(this);

    }

    componentDidMount() {
        if (JSON.parse(sessionStorage.getItem("loginDataSS")) == null) {
            setTimeout(() => {
                this.props.navigate('/');
            }, 200);
        }
        this.getBlogList()
    }

    // Search Blog 
    getBlogList() {
        const { currentPage, title, blogFrom, blogTo, isActive, StatusId } = this.state
        this.setState({ isLoading: true })
        this.props
            .getBlogList_action(title, blogFrom, blogTo, isActive, StatusId)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({
                        blogList: data.data,
                    })
                    setTimeout(() => {
                        this.updateItem(currentPage)
                        this.setState({ isLoading: false })
                    }, 500);
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });

    }

    deleteModal(id) {
        this.setState({ isOpen: true, BlogID: id })
    }

    handleDelete() {
        const { BlogID } = this.state
        // this.setState({ isLoading: true })
        this.props
            .deleteBlog_action(BlogID)
            .then((data) => {
                if (data.error != 1) {
                    toastSuccess("Data deleted successfully!")
                    this.setState({ isLoading: false })
                    setTimeout(() => {
                        this.clearValue()
                    }, 1000);
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    clearValue() {
        this.setState({
            title: '',
            blogFrom: '',
            blogTo: '',
            isActive: '',
            StatusId: '',
            isOpen: false
        })
        setTimeout(() => {
            this.getBlogList()
        }, 500);
    }

    updateItem(item) {
        this.setState({ currentPage: item });
    }
    updateRecordsPerPage = (count) => {
        this.setState({ recordsPerPage: count, currentPage: 1 }, () => window.scrollTo(0, 0));
    };

    toggleFilterCollapse() {
        this.setState((prevstate) => ({
            isFilterShow: !prevstate.isFilterShow
        }))
    }

    handleKeyDown(e) {
        if (e.code == 'Enter') {
            this.getReceiptList()
        }
    }

    handleUpdate(id, IsActive) {
        this.props.navigate('/blogAU', { state: { is_update: true, BlogID: id, IsActive: IsActive } })
    }

    handleNew() {
        this.props.navigate('/blogAU', { state: { is_add: true, IsActive: true } })
    }

    shareOnWhatsApp = () => {
        const { BlogID, BlogTitle, BlogContent } = this.state;
        const baseUrl = window.location.origin;
        const blogUrl = `${baseUrl}/#/blogDetails/${BlogID}`;
        const message = `Title: ${BlogTitle}\n\nFor more information click below link:\n${blogUrl}`
        const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
        window.open(whatsappUrl, "_blank");
    };

    shareOnTwitter = () => {
        const { BlogID, BlogTitle, BlogContent } = this.state;
        const baseUrl = window.location.origin;
        const blogUrl = `${baseUrl}/#/blogDetails/${BlogID}`;
        const message = `Title: ${BlogTitle}\n\nFor more information click below link:\n${blogUrl}`

        const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(message)}`;
        window.open(twitterUrl, "_blank");
    };

    shareOnMessenger = () => {
        const { BlogID, BlogTitle, BlogContent } = this.state;
        const baseUrl = window.location.origin;
        const blogUrl = `${baseUrl}/#/blogDetails/${BlogID}`;
        const message = `Title: ${BlogTitle}\n\nFor more information click below link:\n${blogUrl}`

        const messengerUrl = `https://www.messenger.com/new?text=${encodeURIComponent(message)}`;
        window.open(messengerUrl, "_blank"); // Opens Messenger with pre-filled text
    };

    shareOnFacebook = () => {
        const { BlogID, BlogTitle, BlogContent } = this.state;
        const baseUrl = window.location.origin;
        const blogUrl = `${baseUrl}/#/blogDetails/${BlogID}`;
        const message = `Title: ${BlogTitle}\n\nFor more information click below link:\n${blogUrl}`

        const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(message)}`;
        window.open(facebookUrl, "_blank", "width=600,height=400");
    };

    shareOnInstagram = () => {
        const { BlogID } = this.state;
        const baseUrl = window.location.origin;
        const blogUrl = `${baseUrl}/#/blogDetails/${BlogID}`;

        const messengerUrl = `https://www.instagram.com/new?text=${encodeURIComponent(blogUrl)}`;
        window.open(messengerUrl, "_blank"); // Opens Messenger with pre-filled text
    }

    shareOnLinkedIn = () => {
        const { BlogID } = this.state;
        const baseUrl = window.location.origin;
        const blogUrl = `${baseUrl}/#/blogDetails/${BlogID}`;

        const linkedInUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(blogUrl)}`;

        console.log("LinkedIn Share URL:", linkedInUrl); // Debugging output
        window.open(linkedInUrl, "_blank");
    };

    render() {
        const { title, isOpen, isLoading, currentPage, blogList, isFilterShow, isActive, isSocial, StatusId, recordsPerPage } = this.state

        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = blogList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(blogList.length / recordsPerPage)

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <Header />
                <section class="Blog-section" style={{ marginBottom: '50px', marginTop: '125px' }}>
                    <div class="container">
                        <div class="row">
                            <div class="col-12 col-sm-12 col-lg-12">
                                <div className="card shadow-none border mb-2" >
                                    <div className="card-header py-1">
                                        <h6 className='pt-2' style={{ float: 'left' }}>Blog List</h6>
                                        <div >
                                            <a style={{ float: 'right' }} href="javascript:void(0);"
                                                className="btn btn-purple custom_btn"
                                                title="Filter"
                                                data-toggle="modal"
                                                data-target="#filter_modal"
                                                onClick={() => this.toggleFilterCollapse()}
                                            >
                                                <i className="fa fa-filter" />
                                            </a>
                                            <a style={{ float: 'right' }}
                                                href="javascript:void(0);"
                                                title="Add Role" onClick={() => this.handleNew()}
                                                className="load_document_icon  p-1 px-2 send_credentials-btn mx-1"
                                                data-toggle="modal"
                                                data-target="#add_comment_modal"
                                            >
                                                Add
                                            </a>
                                        </div>
                                    </div>
                                    <ul className="list-group list-group-flush" >
                                        {isFilterShow && <>
                                            <li className="list-group-item">
                                                <div className="row ">
                                                    <div className="col-xl-2 mb-3">
                                                        <div class="form-group">
                                                            <label>Title</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                defaultValue=""
                                                                required=""
                                                                value={title}
                                                                onKeyDown={e => this.handleKeyDown(e)}
                                                                onChange={(e) => this.setState({ title: e.target.value })}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-xl-2 mb-3">
                                                        <div class="form-group">
                                                            <label>Blog From Date</label>
                                                            <DatePicker className="form-control"
                                                                dateFormat="dd-MM-yyyy"
                                                                onKeyDown={e => this.handleKeyDown(e)}
                                                                onChange={(date) => this.setState({ blogFrom: date })}
                                                                selected={this.state.blogFrom}
                                                                peekNextMonth
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                dropdownMode="select"
                                                                placeholderText="From Date"
                                                                customInput={<ExampleCustomInput />}
                                                                dayClassName={() => "example-datepicker-day-class"}
                                                                popperClassName="example-datepicker-class"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-xl-2 mb-3">
                                                        <div class="form-group">
                                                            <label>Blog To Date</label>
                                                            <DatePicker className="form-control"
                                                                dateFormat="dd-MM-yyyy"
                                                                minDate={this.state.blogFrom}
                                                                onKeyDown={e => this.handleKeyDown(e)}
                                                                onChange={(date) => this.setState({ blogTo: date, })}
                                                                selected={this.state.blogTo}
                                                                peekNextMonth
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                dropdownMode="select"
                                                                placeholderText="To Date"
                                                                customInput={<ExampleCustomInput />}
                                                                dayClassName={() => "example-datepicker-day-class"}
                                                                popperClassName="example-datepicker-class"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-xl-2 mb-3">
                                                        <div class="form-group">
                                                            <label>Visibility</label>
                                                            <select className="form-control" value={isActive}
                                                                onChange={(e) => this.setState({ isActive: e.target.value })}
                                                            >
                                                                <option value={''}>Select </option>
                                                                <option value={1}>Activated </option>
                                                                <option value={0}>DeActivated </option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-xl-2 mb-3">
                                                        <div class="form-group">
                                                            <label>Status</label>
                                                            <select className="form-control" value={StatusId}
                                                                onChange={(e) => this.setState({ StatusId: e.target.value })}
                                                            >
                                                                <option value={''}>Select </option>
                                                                <option value={1}>Active </option>
                                                                <option value={0}>Delete </option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-xl-2 mb-3">
                                                        < button style={{ marginTop: '20px' }} className='btn btn-primary mr-2' onClick={() => this.getBlogList()}>
                                                            Search
                                                        </button>
                                                        <button type="button" style={{ marginTop: '20px' }} className='btn btn-dark  mr-2 ms-2' onClick={e => this.clearValue()}>
                                                            Clear
                                                        </button>
                                                    </div>
                                                </div>
                                            </li>
                                        </>}

                                    </ul>
                                </div>
                                <div class="card shadow-none border">
                                    <div class="card-body p-2 pb-0">
                                        <div class="custom_table">
                                            <div class="hack1">
                                                <div class="hack2">
                                                    <table class="table table-bordered table-striped mg-b-0">
                                                        <thead>
                                                            <tr>
                                                                <th style={{ width: '50%' }}>Title </th>
                                                                <th style={{ width: '25%', }} >Blog Date </th>
                                                                <th style={{ width: '18%', }} >Visibility </th>
                                                                <th style={{ width: '7%', textAlign: 'center' }}>Action </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody id='myTable'>
                                                            {
                                                                currentRecords.length > 0 ?
                                                                    currentRecords.map((data, index) => (
                                                                        <>
                                                                            <tr >
                                                                                <td>{data.Title}</td>
                                                                                <td >{moment.utc(data.CreatedDate).format('DD/MM/YYYY')}</td>
                                                                                <td>{data.Status == 'Active' ? 'Activate' : 'DeActivate'}</td>
                                                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>
                                                                                    <div className='D-flex' >
                                                                                        < i className="fa fa-pencil mx-1" title='update' aria-hidden="true" onClick={e => this.handleUpdate(data.BlogID, data.IsActive)}></i>
                                                                                        < i className="fa fa-share mx-1" title='Share' aria-hidden="true" onClick={() => this.setState({ isSocial: true, BlogID: data.BlogID, BlogTitle: data.Title, BlogContent: data.Details })}></i>
                                                                                        {data.StatusId == 1 && < i className="fa fa-trash mx-1" title='delete' aria-hidden="true" onClick={e => this.deleteModal(data.BlogID)}></i>}
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        </>
                                                                    )) : <tr><td colSpan={12} style={{ textAlign: 'center' }}>Record not found</td></tr>
                                                            }

                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="mt-2 float-left">
                                            {
                                                blogList.length > 0 ?
                                                    <Pagination
                                                        nPages={nPages}
                                                        currentPage={currentPage}
                                                        setCurrentPage={this.updateItem}
                                                        totalRecords={blogList.length}
                                                        pageLength={recordsPerPage}
                                                        setPageLength={this.updateRecordsPerPage}
                                                    /> : <></>
                                            }

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>


                </section >
                <Modal show={isSocial} size="md" onHide={() => this.setState({ isSocial: false })}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <h5 className="modal-title" id="staticBackdropLabel">
                                Blog Share
                            </h5>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="pb-2 pt-2"
                        style={{
                            backgroundColor: '#744587',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                        }}
                    >
                        <div className="container text-center p-4">
                            <div class="gt-social style2">
                                <a target='blank' onClick={() => this.shareOnWhatsApp()}><i class="fa fa-whatsapp"></i></a>
                                {/* <a target='blank' onClick={() => this.shareOnFacebook()}><i class="fa fa-facebook-f"></i></a> */}
                                <a target='blank' onClick={() => this.shareOnMessenger()}><img src='assets/img/messenger.png' height={14} width={18} style={{ marginBottom: '3px' }}></img></a>
                                {/* <a target='blank' onClick={() => this.shareOnLinkedIn()}><i class="fa fa-linkedin"></i></a> */}
                                <a target='blank' onClick={() => this.shareOnTwitter()}><i class="fa fa-twitter"></i></a>
                                {/* <a target='blank' onClick={() => this.shareOnInstagram()}><i class="fa fa-instagram"></i></a> */}
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>

                <Modal show={isOpen} style={{ backdropFilter: 'blur(5px)' }} size="md" onHide={() => this.setState({ isOpen: false })}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <h5 className="modal-title" id="staticBackdropLabel">
                                <i class="fa fa-trash-o"></i><span style={{ marginLeft: '5px' }}>Delete</span>
                            </h5>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body  >
                        <h5 className="modal-title" id="staticBackdropLabel" >
                            Do you really want to delete this record ?
                        </h5>

                    </Modal.Body>

                    <Modal.Footer style={{ justifyContent: 'right', padding: '5px 10px' }}>
                        <div class="row">
                            <div class="col-md-12 text-right" >
                                <a
                                    onClick={() => this.handleDelete()}
                                    className="load_document_icon  p-1 pb-2 px-3 send_credentials-btn mx-1"
                                    data-toggle="modal"
                                    data-target="#add_comment_modal"
                                >
                                    Yes
                                </a>
                                <a
                                    class="btn btn-outline-secondary"
                                    style={{ verticalAlign: 'middle', padding: '5px 10px' }}
                                    onClick={() => this.setState({ isOpen: false })}
                                >
                                    Back
                                </a>
                            </div>
                        </div>

                    </Modal.Footer>
                </Modal>

                {/* <Modal show={this.state.isOpen} size="md" style={{ backdropFilter: 'blur(5px)' }} onHide={() => this.setState({ isOpen: false })}>
                    <Modal.Header>
                        <Modal.Title>
                            <h5 className="modal-title" id="staticBackdropLabel">
                                <i class="fa fa-trash-o"></i><span style={{ marginLeft: '5px' }}>Delete</span>
                            </h5>
                        </Modal.Title>
                    </Modal.Header>


                    <Modal.Footer style={{ justifyContent: 'right', padding: '5px 10px' }}>
                    <div class="row">
                            <div class="col-md-12 text-right" >
                                <a
                                    onClick={() => this.handleDelete()}
                                    className="load_document_icon  p-1 pb-2 px-3 send_credentials-btn mx-1"
                                    data-toggle="modal"
                                    data-target="#add_comment_modal"
                                >
                                    Yes
                                </a>
                                <button
                                    onClick={() => this.setState({ isOpen: false })}
                                    class="btn btn-secondary p-1 pb-2 px-3"
                                >
                                    Back
                                </button>
                            </div>
                        </div>

                    </Modal.Footer>
                </Modal> */}
            </>
        )
    }
}
export default withRouter(connect(null, { fill_action, getBlogList_action, deleteBlog_action })(BlogList));